import cx from 'classnames';
import * as React from 'react';
import {
  Accordion as ReactAccessibleAccordion,
  AccordionItem as ReactAccessibleAccordionItem,
  AccordionItemBody as ReactAccessibleAccordionItemBody,
  AccordionItemTitle as ReactAccessibleAccordionItemTitle,
} from 'react-accessible-accordion';

import './Accordion.scss';

type Props = {
  className?: string;
  // from react-accessible-accordion
  accordion?: boolean;
  onChange?: (uuids: string[]) => void;
  children?: React.ReactNode;
};

function Accordion({ accordion, className, ...others }: Props) {
  return (
    <ReactAccessibleAccordion
      {...others}
      accordion={accordion || false}
      className={cx('Accordion', className)}
    />
  );
}

type AccordionItemProps = {
  className?: string;
  disabled?: boolean;
  expanded?: boolean;
  uuid?: string;
  children?: React.ReactNode;
};

function AccordionItem({ className, disabled, expanded, ...others }: AccordionItemProps) {
  return (
    <ReactAccessibleAccordionItem
      {...others}
      expanded={expanded}
      className={cx('AccordionItem', disabled && 'AccordionItem--disabled', className)}
      hideBodyClassName="AccordionItem--hidden"
    />
  );
}

type AccordionItemBodyProps = {
  className?: string;
  // retain styling, but don't require accordion scaffolding
  faux?: boolean;
  children?: React.ReactNode;
};

function AccordionItemBody({ className, faux, ...others }: AccordionItemBodyProps) {
  const classNames = cx('AccordionItemBody', className);

  if (faux) {
    return <div {...others} className={cx(classNames, 'AccordionItemBody--faux')} />;
  }

  return (
    <ReactAccessibleAccordionItemBody
      {...others}
      className={classNames}
      hideBodyClassName="AccordionItemBody--hidden"
    />
  );
}

type AccordionItemTitleProps = {
  className?: string;
  // retain styling, but don't require accordion scaffolding
  faux?: boolean;
  children?: React.ReactNode;
};

function AccordionItemTitle({ className, faux, ...others }: AccordionItemTitleProps) {
  const classNames = cx('AccordionItemTitle', className);

  if (faux) {
    return <header {...others} className={cx(classNames, 'AccordionItemTitle--faux')} />;
  }

  return (
    <ReactAccessibleAccordionItemTitle
      {...others}
      className={classNames}
      hideBodyClassName="AccordionItemTitle--hidden"
    />
  );
}

export { Accordion, AccordionItem, AccordionItemBody, AccordionItemTitle };
